import React from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { TreeLink } from '../../../app/Links'

export default () => {}

export function TreeIdCells({ treeId, isResearcherTree }) {
  const { t } = useTranslation()
  return (
    <Grid>
      <Cell columns={6}>
        <DataBlock
          heading={t('queues.treeId', 'Tree ID')}
          data={(treeId && <TreeLink treeId={treeId} newTab />) || ''}
        />
      </Cell>
      {isResearcherTree !== 'hide' && (
        <Cell columns={6}>
          <DataBlock
            heading={t('queues.isResearcherTree', 'Is it a Researcher Tree?')}
            data={
              isResearcherTree != null &&
              (isResearcherTree.toString().toLowerCase() === 'true' ? t('yes', 'Yes') : t('no', 'No'))
            }
          />
        </Cell>
      )}
    </Grid>
  )
}

export function TreeIdGrid({ treeId, isResearcherTree }) {
  const { t } = useTranslation()
  return (
    <Grid>
      <Cell columns={6}>
        <DataBlock heading={t('queues.treeId', 'Tree ID')} data={treeId && <TreeLink treeId={treeId} newTab />} />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('queues.isResearcherTree', 'Is it a Researcher Tree?')}
          data={isResearcherTree && (isResearcherTree.toLowerCase() === 'true' ? t('yes', 'Yes') : t('no', 'No'))}
        />
      </Cell>
    </Grid>
  )
}

export function TreeIdRows({ treeId, isResearcherTree }) {
  const { t } = useTranslation()

  return (
    <>
      <DataBlock heading={t('queues.treeId', 'Tree ID')} data={treeId ? <TreeLink treeId={treeId} newTab /> : ''} />
      <DataBlock
        heading={t('queues.isResearcherTree', 'Is it a Researcher Tree?')}
        data={(isResearcherTree && (isResearcherTree.toLowerCase() === 'true' ? t('yes', 'Yes') : t('no', 'No'))) || ''}
      />
    </>
  )
}
